<script>
import { useElixioConnectStore } from '../../stores/elixioConnect'
import EcErrorBanner from '../ui/EcErrorBanner.vue'

export default {
  name: 'ModuleSimpleConnect',
  components: { EcErrorBanner },
  props: {
    service: { type: Object, required: true },
    organization: { type: Object, required: true },
  },
  data() {
    return {
      store: useElixioConnectStore(),
      loading: false,
      errors: [],
      serviceData: { ...this.service },
    }
  },
  computed: {
    t() {
      return this.$ecTranslate || ((k) => k)
    },
    notify() {
      return this.$ecNotify || (() => {})
    },
    confirm() {
      return this.$ecConfirm || ((msg) => Promise.resolve(window.confirm(msg)))
    },
  },
  watch: {
    service(val) {
      this.serviceData = { ...val }
    },
  },
  methods: {
    extractErrors(error) {
      const data = error?.response?.data
      if (!data) return [this.t('ELIXIO_CONNECT.SOMETHING_WENT_WRONG')]

      const msgs = []

      const apiErrors = data?.response?.errors ?? data?.errors
      if (Array.isArray(apiErrors) && apiErrors.length) {
        msgs.push(...apiErrors.map((e) => e.detail ?? e.title ?? String(e)))
      }

      if (!msgs.length && data?.response?.detail) {
        msgs.push(data.response.detail)
      }
      if (!msgs.length && data?.response?.title) {
        msgs.push(data.response.title)
      }
      if (!msgs.length && data?.response?.message) {
        msgs.push(data.response.message)
      }
      if (!msgs.length && data?.message) {
        msgs.push(data.message)
      }

      return msgs.length ? msgs : [this.t('ELIXIO_CONNECT.SOMETHING_WENT_WRONG')]
    },
    async subscribe() {
      this.loading = true
      this.errors = []
      try {
        const result = await this.store.subscribe(this.organization.id, {
          service_name: this.service.name,
          service_type: this.service.slug,
        })

        if (result.auth_data) {
          this.notify(this.t('ELIXIO_CONNECT.LOGIN_TO_YOUR_ACCOUNT'), 'success')

          const authUrl = result.auth_data.auth_url ?? null
          const serviceId = result.service_data?.elixio_service_id ?? null
          this.serviceData.id = serviceId

          if (authUrl) {
            const popup = window.open(authUrl, '_blank', 'width=600,height=600')
            if (popup) {
              const timer = setInterval(() => {
                if (popup.closed) {
                  clearInterval(timer)
                  this.$emit('subscribed', { success: true, service: this.serviceData })
                  this.notify(this.t('ELIXIO_CONNECT.AUTH_FINISHED'), 'success')
                }
              }, 1000)
            }
          } else {
            this.notify(this.t('ELIXIO_CONNECT.NOT_CONFIGURED_YET'), 'warning')
          }
        }
      } catch (error) {
        console.error('Simple Connect Subscribe =>', error)
        this.errors = this.extractErrors(error)
        this.notify(this.errors[0] ?? this.t('ELIXIO_CONNECT.SOMETHING_WENT_WRONG'), 'error')
      } finally {
        this.loading = false
      }
    },
    async handleActivate() {
      const confirmed = await this.confirm(this.t('ELIXIO_CONNECT.ELIXIO_CONNECT_CONFIRM_THIS_SUBSCRIPTION'))
      if (confirmed) {
        await this.subscribe()
      }
    },
  },
}
</script>

<template>
  <div>
    <EcErrorBanner v-if="errors.length" :errors="errors" class="ec-mb-3" />

    <a href="#" class="ec-simple-connect-link" @click.prevent="handleActivate">
      <span v-if="!service.is_active && !service.is_deactivated">
        {{ t('ELIXIO_CONNECT.ACTIVATE') }} {{ service.name }}
      </span>
      <span v-else>
        {{ t('ELIXIO_CONNECT.DEACTIVATE') }} {{ service.name }}
      </span>
    </a>
  </div>
</template>
